module.exports = __webpack_public_path__ + "static/media/arrow-down-darkgrey.8419e393.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down-darkgrey.svg
// module id = 680
// module chunks = 0